import Component from './instagram_prize_dialog.vue'
export default Component
